module.exports = __webpack_public_path__ + "img/Logo.a6076a40.png";